import { useRuntimeVariables } from 'app-kit'
import { AuthedAxiosRequests, useGeckoAuth } from 'features/auth'
import React from 'react'

export interface SendSlackMessageRequest {
  channel_id: string
  site_name: string
  unit_name: string
  component_name: string
  component_slug: string
  inspection_slug: string
  title: string | undefined
  message: string | undefined
  forecast_link: string | undefined
  data_ops_link: string | undefined
  sales_representative: string | undefined
  data_lead: string | undefined
  supervisor: string | undefined
  operations_data_lead: string | undefined
  qa_qc_lead: string | undefined
}

export function useSlackAPI() {
  const { ALERTS_URL } = useRuntimeVariables()
  const { authorizedAxios: axios } = useGeckoAuth()

  return React.useMemo(() => {
    return {
      getSlackChannels: () => getSlackChannels(ALERTS_URL, axios),
      getSlackUsers: () => getSlackUsers(ALERTS_URL, axios),
      getSlackGroups: () => getSlackGroups(ALERTS_URL, axios),
      sendSlackNotification: (
        request: SendSlackMessageRequest,
        finalApproval?: boolean
      ) => sendSlackNotification(ALERTS_URL, axios, request, finalApproval),
    }
  }, [ALERTS_URL, axios])
}

async function getSlackChannels(alertsUrl: string, axios: AuthedAxiosRequests) {
  return await axios.get(`${alertsUrl}/api/v1/publisher/slack/channels`, {
    headers: { 'Content-Type': 'application/json' },
  })
}

async function getSlackUsers(alertsUrl: string, axios: AuthedAxiosRequests) {
  return await axios.get(`${alertsUrl}/api/v1/publisher/slack/users`, {
    headers: { 'Content-Type': 'application/json' },
  })
}

async function getSlackGroups(alertsUrl: string, axios: AuthedAxiosRequests) {
  return await axios.get(`${alertsUrl}/api/v1/publisher/slack/groups`, {
    headers: { 'Content-Type': 'application/json' },
  })
}

async function sendSlackNotification(
  alertsUrl: string,
  axios: AuthedAxiosRequests,
  request: SendSlackMessageRequest,
  finalApproval?: boolean
) {
  if (finalApproval) {
    return await axios.post(
      `${alertsUrl}/api/v1/publisher/slack/notifications/ready-to-publish`,
      request,
      { headers: { 'Content-Type': 'application/json' } }
    )
  } else {
    return await axios.post(
      `${alertsUrl}/api/v1/publisher/slack/notifications/ready-for-approval`,
      request,
      { headers: { 'Content-Type': 'application/json' } }
    )
  }
}
